// Factory central de queryKeys para TanStack Query.
//
// Todas las keys van scopeadas por establishment (estId) para garantizar
// aislamiento entre establecimientos: al hacer switch-establishment las keys
// cambian de número y los caches no se mezclan. Centralizar acá evita strings
// magicos repartidos por el codigo y permite invalidar de forma consistente.
export const queryKeys = {
    animals: (estId) => ["animals", estId],
    // Variante que incluye toros de banco de padres (isStudBank=true), excluidos
    // por default del listado general. Key separada para no pisar el cache
    // de queryKeys.animals en las pantallas que SÍ deben seguir sin verlos
    // (movimientos, tactos, tratamientos, pesajes, nacimientos).
    animalsWithStudBank: (estId) => ["animals", estId, "withStudBank"],
    animal: (estId, id) => ["animals", estId, id],
    weights: (estId, animalId) =>
        animalId
            ? ["weights", estId, "animal", animalId]
            : ["weights", estId],
    catalogs: (estId) => ["catalogs", estId],
    snapshot: (estId) => ["snapshot", estId],
    // Detalle del establecimiento activo (renspa, provincia, contacto, coords…)
    // y sus colaboradores. Se cachean para que /establecimiento funcione offline.
    establishment: (estId) => ["establishment", estId],
    collaborators: (estId) => ["collaborators", estId],
    herds: (estId) => ["herds", estId],
    births: (estId) => ["births", estId],
    treatments: (estId) => ["treatments", estId],
    treatmentTypes: (estId) => ["treatmentTypes", estId],
    pregnancyChecks: (estId) => ["pregnancyChecks", estId],
    movements: (estId) => ["movements", estId],
    observations: (estId) => ["observations", estId],
    notes: (estId) => ["notes", estId],
    // Reporte de Stock agregado por el backend (reports/stock). Se cachea para
    // que /reportes muestre offline la última agregación calculada online.
    stock: (estId) => ["stock", estId],
    services: (estId) => ["services", estId],
    lots: (estId) => ["lots", estId],
    animalMovements: (estId, animalId) => ["animalMovements", estId, animalId],
};
